<template>
  <div class="dialog-wrap">
    <el-dialog :title="title"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               @open="open()"
               :append-to-body="true"
               width="500px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="院校名称"
                      prop="recruit_college"
                      v-if="title == '编辑录取名单'">
          <el-select v-model="dataForm.recruit_college"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="collegeChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业名称"
                      prop="major">
          <el-select v-model="dataForm.major"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="majorChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in majorList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
              <span>{{ `（${item.code}）${item.name}` }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学院名称"
                      prop="academy">
          <el-select v-model="dataForm.academy"
                     filterable
                     clearable
                     placeholder="请选择"
                     @change="academyChange"
                     style="width: 100%">
            <el-option v-for="(item, index) in academylist"
                       :key="index"
                       :label="item.academy_name"
                       :value="{
                      value: item.academy_code,
                      label: item.academy_name,
                      directions: item.directions,
                    }">
              <span>{{
                `（${item.academy_code}）${item.academy_name}`
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="方向名称"
                      prop="direction">
          <el-select v-model="dataForm.direction"
                     filterable
                     clearable
                     placeholder="请选择"
                     style="width: 100%">
            <el-option v-for="(item, index) in directionlist"
                       :key="index"
                       :label="item.direction"
                       :value="{
                      value: item.direction_code,
                      label: item.direction,
                    }">
              <span>{{
                `（${item.direction_code}）${item.direction}`
              }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考生姓名"
                      prop="exam_student_name">
          <el-input v-model="dataForm.exam_student_name"
                    placeholder="请输入考生姓名"></el-input>
        </el-form-item>
        <el-form-item label="考生编号"
                      prop="exam_student_no">
          <el-input v-model="dataForm.exam_student_no"
                    placeholder="请输入考生编号"></el-input>
        </el-form-item>
        <el-form-item label="录取形式"
                      prop="recruit_type">
          <el-select v-model="dataForm.recruit_type"
                     placeholder="请选择"
                     clearable>
            <el-option label="一志愿"
                       value="1">
            </el-option>
            <el-option label="调剂"
                       value="2">
            </el-option>
            <el-option label="推免"
                       value="3">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一志愿院校"
                      prop="college"
                      v-if="dataForm.recruit_type==2">
          <el-select v-model="dataForm.college"
                     filterable
                     placeholder="请选择"
                     style="width: 320px">
            <el-option v-for="(item, index) in $store.state.collegeList"
                       :key="index"
                       :label="item.name"
                       :value="{ value: item.code, label: item.name }">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="初试总分"
                      prop="first_exam_score">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.first_exam_score">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="复试成绩"
                      prop="second_exam_score">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.second_exam_score">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="录取成绩"
                      prop="total_exam_score">
          <el-input placeholder="请输入你的分数"
                    v-model="dataForm.total_exam_score">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>
        <el-form-item label="学习方式"
                      prop="recruit_college_enrol_type">
          <el-select v-model="dataForm.recruit_college_enrol_type"
                     placeholder="请选择"
                     clearable>
            <el-option label="全日制"
                       value="1">
            </el-option>
            <el-option label="非全日制"
                       value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="录取类别"
                      prop="recruit_fix_direct_type">
          <el-select v-model="dataForm.recruit_fix_direct_type"
                     placeholder="请选择"
                     clearable>
            <el-option label="非定向"
                       value="1">
            </el-option>
            <el-option label="定向"
                       value="2">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注"
                      prop="remark">
          <el-input v-model="dataForm.remark"
                    placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>

      <div style="display:flex; justify-content: flex-end;marginTop:30px">
        <div>
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary"
                     @click="handleSubmit">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  recruitPrepareCreated,
  recruitPrepareDetail,
  recruitPreparePut,
} from '@/api/admission'
import { collegeMajorList, majorinfo } from '@/api/common'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    detail: {
      type: Object,
      default: () => {
        return {}
      },
    },
    title: {
      type: String,
      default: () => {
        return '新建复试名单'
      },
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      rules: {
        recruit_college: [
          { required: true, message: '请选择院校', trigger: 'change' },
        ],
        major: [
          { required: true, message: '请选择专业', trigger: 'change' },
        ],
        academy: [
          { required: true, message: '请选择学院', trigger: 'change' },
        ],
        exam_student_name: [
          { required: true, message: '请输入考生姓名', trigger: 'blur' },
        ],
        exam_student_no: [
          { required: true, message: '请输入考生编号', trigger: 'blur' },
        ],
        recruit_type: [
          { required: true, message: '请选择录取形式', trigger: 'change' },
        ],
        first_exam_score: [
          { required: true, message: '请输入你的分数', trigger: 'blur' },
        ],
        second_exam_score: [
          { required: true, message: '请输入你的分数', trigger: 'blur' },
        ],
        total_exam_score: [
          { required: true, message: '请输入你的分数', trigger: 'blur' },
        ],
        recruit_college_enrol_type: [
          { required: true, message: '请选择学习方式', trigger: 'change' },
        ],
        recruit_fix_direct_type: [
          { required: true, message: '请选择录取类别', trigger: 'change' },
        ],
      },
      dataForm: {
        exam_student_name: '',
        exam_student_no: '',
        exam_score_politics: '',
        exam_score_language: '',
        exam_score_business_1: '',
        exam_score_business_2: '',
        exam_score_total: '',
        remark: '',
      },
      rowDetail: {},
      majorList: [],
      academylist: [],
      directionlist: [],
    }
  },

  methods: {
    // 编辑时院校变化 → 重置专业/学院/方向并加载专业列表
    collegeChange(e) {
      this.$set(this.dataForm, 'major', {})
      this.$set(this.dataForm, 'academy', {})
      this.$set(this.dataForm, 'direction', {})
      this.academylist = []
      this.directionlist = []
      this.fetchMajor(e.value)
    },
    // 专业下拉数据（新增时按父级院校加载）
    fetchMajor(college_code) {
      collegeMajorList({ college_code, isPaging: 0 }).then((res) => {
        this.majorList = res.list
      })
    },
    // 专业变化 → 加载学院/方向（分数线同款三级联动）
    majorChange(e) {
      this.$set(this.dataForm, 'academy', {})
      this.$set(this.dataForm, 'direction', {})
      this.directionlist = []
      this.fetchMajorInfo(this.dataForm.recruit_college.value, e.value)
    },
    fetchMajorInfo(college_code, major_code) {
      return new Promise((resolve) => {
        majorinfo({ college_code, major_code, isPaging: 0 }).then((res) => {
          this.academylist = res.academys
          resolve(res)
        })
      })
    },
    // 学院变化 → 设置方向列表
    academyChange(e) {
      this.$set(this.dataForm, 'direction', {})
      this.directionlist = e.directions || []
    },
    handleClose() {
      this.$emit('close')
      this.dataForm = {}
      this.majorList = []
      this.academylist = []
      this.directionlist = []
      this.$refs['dataForm'].resetFields()
    },
    open() {
      if (this.title == '新建录取名单') {
        // 新增：院校由父级带入作为默认值（仅用于联动传参，界面不显示）
        this.$set(this.dataForm, 'recruit_college', {
          value: this.detail.college_code,
          label: this.detail.college_name,
        })
        this.fetchMajor(this.detail.college_code)
      } else {
        // 编辑：回显该行 院校/专业/学院/方向
        recruitPrepareDetail({ id: this.rowId }).then((res) => {
          this.rowDetail = res
          this.$set(this.dataForm, 'exam_student_name', res.exam_student_name)
          this.$set(this.dataForm, 'exam_student_no', res.exam_student_no)
          this.$set(this.dataForm, 'recruit_type', res.recruit_type + '')
          this.$set(this.dataForm, 'first_exam_score', res.first_exam_score)
          this.$set(this.dataForm, 'second_exam_score', res.second_exam_score)
          this.$set(this.dataForm, 'total_exam_score', res.total_exam_score)
          this.$set(
            this.dataForm,
            'recruit_college_enrol_type',
            res.recruit_college_enrol_type + ''
          )
          this.$set(
            this.dataForm,
            'recruit_fix_direct_type',
            res.recruit_fix_direct_type + ''
          )
          this.$set(this.dataForm, 'remark', res.remark)
          if (res.first_college_name) {
            this.$set(this.dataForm, 'college', {
              value: res.first_college_code,
              label: res.first_college_name,
            })
          }
          // 回显 院校/专业/学院/方向
          this.$set(this.dataForm, 'recruit_college', {
            value: res.recruit_college_code,
            label: res.recruit_college_name,
          })
          this.$set(this.dataForm, 'major', {
            value: res.recruit_major_code,
            label: res.recruit_major_name,
          })
          this.$set(this.dataForm, 'academy', {
            value: res.recruit_academy_code,
            label: res.recruit_academy_name,
          })
          this.$set(this.dataForm, 'direction', {
            value: res.recruit_direction_code,
            label: res.recruit_direction_name,
          })
          // 按回显院校加载专业列表
          this.fetchMajor(res.recruit_college_code)
          // 按 院校+专业 加载学院/方向（=== 匹配当前行学院，兜底方向）
          this.fetchMajorInfo(
            res.recruit_college_code,
            res.recruit_major_code
          ).then((info) => {
            const academys = info.academys || []
            const target = academys.find(
              (v) => v.academy_code === res.recruit_academy_code
            )
            if (target && Array.isArray(target.directions)) {
              this.directionlist = target.directions
            } else if (res.recruit_direction_code) {
              this.directionlist = [
                {
                  direction_code: res.recruit_direction_code,
                  direction: res.recruit_direction_name,
                },
              ]
            } else {
              this.directionlist = []
            }
          })
        })
      }
    },
    handleSubmit() {
      console.log('this.detail', this.detail)
      console.log('this.dataform', this.dataForm)

      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          if (this.title == '新建录取名单') {
            let data = {
              year: this.detail.current_search_year,
              exam_student_no: this.dataForm.exam_student_no,
              exam_student_name: this.dataForm.exam_student_name,
              recruit_college_code: this.detail.college_code,
              recruit_college_name: this.detail.college_name,
              recruit_academy_code: this.dataForm.academy.value,
              recruit_academy_name: this.dataForm.academy.label,
              recruit_major_code: this.dataForm.major.value,
              recruit_major_name: this.dataForm.major.label,
              recruit_direction_code: this.dataForm.direction.value,
              recruit_direction_name: this.dataForm.direction.label,
              recruit_college_enrol_type:
                this.dataForm.recruit_college_enrol_type,
              recruit_type: this.dataForm.recruit_type,
              recruit_fix_direct_type: this.dataForm.recruit_fix_direct_type,
              first_exam_score: this.dataForm.first_exam_score,
              second_exam_score: this.dataForm.second_exam_score,
              total_exam_score: this.dataForm.total_exam_score,
              remark: this.dataForm.remark,
            }
            if (this.dataForm.college) {
              data.first_college_code = this.dataForm.college.value
              data.first_college_name = this.dataForm.college.label
            }
            recruitPrepareCreated(data).then((res) => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`操作成功`)
            })
          } else {
            console.log('this.dataform', this.dataForm.recruit_college)
            let data = {
              id: this.rowId,
              year: this.detail.current_search_year,
              exam_student_no: this.dataForm.exam_student_no,
              exam_student_name: this.dataForm.exam_student_name,
              recruit_college_code: this.dataForm.recruit_college.value,
              recruit_college_name: this.dataForm.recruit_college.label,
              recruit_academy_code: this.dataForm.academy.value,
              recruit_academy_name: this.dataForm.academy.label,
              recruit_major_code: this.dataForm.major.value,
              recruit_major_name: this.dataForm.major.label,
              recruit_direction_code: this.dataForm.direction.value,
              recruit_direction_name: this.dataForm.direction.label,
              recruit_college_enrol_type:
                this.dataForm.recruit_college_enrol_type,
              recruit_type: this.dataForm.recruit_type,
              recruit_fix_direct_type: this.dataForm.recruit_fix_direct_type,
              first_exam_score: this.dataForm.first_exam_score,
              second_exam_score: this.dataForm.second_exam_score,
              total_exam_score: this.dataForm.total_exam_score,
              remark: this.dataForm.remark,
            }
            if (this.dataForm.college) {
              data.first_college_code = this.dataForm.college.value
              data.first_college_name = this.dataForm.college.label
            }
            recruitPreparePut(data).then((res) => {
              this.handleClose()
              this.$emit('submit')
              this.$message.success(`修改成功`)
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.cover-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  width: 112px;
  height: 112px;
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  max-width: 100%;
  max-height: 200px;
  line-height: 100px;
  text-align: center;
}
.cover {
  display: block;
  max-width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin: 0 auto;
}
.border {
  padding: 10px;
  width: 100%;
  border: 1px dashed #d9d9d9;
}
.desc {
  margin-top: 10px;
  font-weight: normal;
  font-size: 12px;
  color: #cccccc;
}
</style>
